export const TITLE = 'Online Certificate';
export const DB_PREFIX = 'certificateDBS';
export const DB_PREFIX_INFO = 'info';
export const DB_PREFIX_REGISTER = 'isRegisteredInDBS';
